/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Discover_SubInputs */

const th_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ค้นหาทัวร์นาเมนต์ ลีก แคมป์ และโชว์เคส กรองตามเมือง รูปแบบ หรือสถานะ`)
};

const en_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find tournaments, leagues, camps, and showcases. Browse by city, format, or status.`)
};

const ja_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トーナメント、リーグ、キャンプ、ショーケースを探す。都市・形式・状況から絞り込めます。`)
};

const zh_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`寻找锦标赛、联赛、训练营和展示赛。可按城市、赛制或状态浏览。`)
};

const es_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encuentra torneos, ligas, campus y exhibiciones. Explora por ciudad, formato o estado.`)
};

const pt_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Encontre torneios, ligas, clínicas e showcases. Explore por cidade, formato ou situação.`)
};

const id_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temukan turnamen, liga, kamp dan showcase. Telusuri menurut kota, format atau status.`)
};

const fr_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouvez tournois, championnats, stages et showcases. Explorez par ville, format ou statut.`)
};

const tl_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maghanap ng torneo, liga, camp at showcase. Suriin ayon sa lungsod, pormat o katayuan.`)
};

const vi_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tìm giải đấu, giải vô địch, trại tập và showcase. Duyệt theo thành phố, thể thức hoặc trạng thái.`)
};

const ko_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`토너먼트, 리그, 캠프, 쇼케이스를 찾아보세요. 도시, 방식, 상태로 둘러볼 수 있습니다.`)
};

const de_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finde Turniere, Ligen, Camps und Showcases. Nach Stadt, Format oder Status stöbern.`)
};

const ru_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найдите турниры, лиги, лагеря и шоукейсы. Ищите по городу, формату или статусу.`)
};

const tr_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Turnuvaları, ligleri, kampları ve showcase'leri bulun. Şehre, formata veya duruma göre gezinin.`)
};

const it_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova tornei, campionati, camp e showcase. Sfoglia per città, formato o stato.`)
};

const pl_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź turnieje, ligi, obozy i pokazy. Przeglądaj według miasta, formatu lub statusu.`)
};

const uk_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Знайдіть турніри, ліги, табори та шоукейси. Шукайте за містом, форматом або статусом.`)
};

const hi_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टूर्नामेंट, लीग, कैंप और शोकेस खोजें। शहर, प्रारूप या स्थिति के अनुसार देखें।`)
};

const ar_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابحث عن البطولات والدوريات والمعسكرات والعروض. تصفّح حسب المدينة أو النظام أو الحالة.`)
};

const ms_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari kejohanan, liga, kem dan showcase. Layari mengikut bandar, format atau status.`)
};

const bn_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`টুর্নামেন্ট, লিগ, ক্যাম্প ও শোকেস খুঁজুন। শহর, ধরন বা অবস্থা অনুযায়ী দেখুন।`)
};

const zh_tw2_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尋找錦標賽、聯賽、訓練營與觀摩賽。可依城市、賽制或狀態瀏覽。`)
};

const zh_hk2_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尋找錦標賽、聯賽、訓練營與表演賽。可依城市、賽制或狀態瀏覽。`)
};

const ur_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹورنامنٹ، لیگ، کیمپ اور شوکیس تلاش کریں۔ شہر، طریقے یا حالت کے مطابق دیکھیں۔`)
};

const fa_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تورنمنت، لیگ، اردو و نمایش پیدا کنید. بر پایهٔ شهر، قالب یا وضعیت مرور کنید.`)
};

const sw_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tafuta mashindano, ligi, kambi na maonyesho. Vinjari kwa mji, muundo au hali.`)
};

const nl_discover_sub = /** @type {(inputs: Discover_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vind toernooien, competities, kampen en showcases. Blader op stad, opzet of status.`)
};

/**
* | output |
* | --- |
* | "Find tournaments, leagues, camps, and showcases. Browse by city, format, or status." |
*
* @param {Discover_SubInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const discover_sub = /** @type {((inputs?: Discover_SubInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Discover_SubInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_discover_sub(inputs)
	if (locale === "ja") return ja_discover_sub(inputs)
	if (locale === "zh") return zh_discover_sub(inputs)
	if (locale === "es") return es_discover_sub(inputs)
	if (locale === "pt") return pt_discover_sub(inputs)
	if (locale === "id") return id_discover_sub(inputs)
	if (locale === "fr") return fr_discover_sub(inputs)
	if (locale === "tl") return tl_discover_sub(inputs)
	if (locale === "vi") return vi_discover_sub(inputs)
	if (locale === "ko") return ko_discover_sub(inputs)
	if (locale === "de") return de_discover_sub(inputs)
	if (locale === "ru") return ru_discover_sub(inputs)
	if (locale === "tr") return tr_discover_sub(inputs)
	if (locale === "it") return it_discover_sub(inputs)
	if (locale === "pl") return pl_discover_sub(inputs)
	if (locale === "uk") return uk_discover_sub(inputs)
	if (locale === "hi") return hi_discover_sub(inputs)
	if (locale === "ar") return ar_discover_sub(inputs)
	if (locale === "ms") return ms_discover_sub(inputs)
	if (locale === "bn") return bn_discover_sub(inputs)
	if (locale === "zh-TW") return zh_tw2_discover_sub(inputs)
	if (locale === "zh-HK") return zh_hk2_discover_sub(inputs)
	if (locale === "ur") return ur_discover_sub(inputs)
	if (locale === "fa") return fa_discover_sub(inputs)
	if (locale === "sw") return sw_discover_sub(inputs)
	if (locale === "nl") return nl_discover_sub(inputs)
	return en_discover_sub(inputs)
});